import moment from 'moment'
import { HARDCODED_PTO_REQUEST_TYPE } from '../../constants'
import {
  PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED_ENUM,
  PERSONAL_DATA_CHANGE_REQUEST_TYPE_CONTRACT_ENUM,
  PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT_ENUM,
  PERSONAL_DATA_CHANGE_REQUEST_TYPE_PAYROLL_ENUM,
  PTO_REQUEST_PAID_TYPE_OF_TIME_OFF_ENUM,
  PTO_REQUEST_STATUS_EXPIRED_ENUM,
  PTO_REQUEST_STATUS_REQUESTED_ENUM,
  PTO_REQUEST_UNPAID_TYPE_OF_TIME_OFF_ENUM,
} from '../../shared/constants'

export const getPaidTypeLabel = paidType => {
  if (paidType == PTO_REQUEST_PAID_TYPE_OF_TIME_OFF_ENUM) {
    return 'Paid'
  } else if (paidType == PTO_REQUEST_UNPAID_TYPE_OF_TIME_OFF_ENUM) {
    return 'Unpaid'
  }
  return ''
}

export const createDescription = (item, documentTypes) => {
  switch (item.type) {
    case PERSONAL_DATA_CHANGE_REQUEST_TYPE_DOCUMENT_ENUM: {
      const documentType = documentTypes.find(documentType => {
        return Number(documentType.id) === Number(item.newData.documentTypeId)
      })
      return documentType ? documentType.name : 'Cannot find document type'
    }
    case PERSONAL_DATA_CHANGE_REQUEST_TYPE_CONTRACT_ENUM: {
      return 'Address Edition'
    }
    case PERSONAL_DATA_CHANGE_REQUEST_TYPE_PAYROLL_ENUM: {
      return 'Payroll Data'
    }
    case HARDCODED_PTO_REQUEST_TYPE: {
      return `${getPaidTypeLabel(item.paidType)} Time Off`
    }
  }
}

export const formatDataToView = (items, documentTypes) =>
  items.reduce(
    (acc, item) => {
      if (item.status === PTO_REQUEST_STATUS_EXPIRED_ENUM) {
        acc.historyData.push({
          ...item,
          name: createDescription(item, documentTypes),
        })
        return acc
      }
      if (item.status === PERSONAL_DATA_CHANGE_REQUEST_STATUS_REQUESTED_ENUM) {
        acc.pendingData.push({
          ...item,
          name: createDescription(item, documentTypes),
        })
      } else {
        acc.historyData.push({
          ...item,
          name: createDescription(item, documentTypes),
        })
      }
      return acc
    },
    { pendingData: [], historyData: [] },
  )

export const formatTimeOffRequestsToView = items => {
  if (!items) return []
  return items.map(request => {
    const isExpired =
      moment(request.startDate)
        .startOf('day')
        .isBefore(moment().startOf('day')) &&
      request.status == PTO_REQUEST_STATUS_REQUESTED_ENUM

    return {
      ...request,
      editedBy: request.actorName,
      type: HARDCODED_PTO_REQUEST_TYPE,
      comment: request.rejectReason,
      isPTO: true,
      status: isExpired ? PTO_REQUEST_STATUS_EXPIRED_ENUM : request.status,
    }
  })
}
